export default function CloseIcon () {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M0.5 0.5L9.5 9.5" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.5 0.5L0.5 9.5" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}